"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifecycleChartsSettingsChartTypeComponent = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const LifecyclePageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/LifecyclePageDataProvider");
const LifecycleChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/model/LifecycleChartSettingsJSONModel");
const LifecycleChartsSettingsChartTypeComponent = () => {
    const lifecyclePageDataContext = (0, LifecyclePageDataProvider_1.useLifecyclePageDataContext)();
    const onRadioChange = (0, use_custom_compare_1.useCustomCompareCallback)((e) => {
        const value = e.target.value;
        const chartSettingsJSONModel = lifecyclePageDataContext.stateFns.getURLJSONModel().getChartSettingsJSONModel();
        chartSettingsJSONModel.setChartType(value);
        lifecyclePageDataContext.stateFns.onChartSettingsChanged(chartSettingsJSONModel.serialize());
    }, [lifecyclePageDataContext.stateFns], lodash_1.default.isEqual);
    const { inProgress, loaded } = lifecyclePageDataContext.state.status;
    const { isError } = lifecyclePageDataContext.state.error;
    const chartType = lifecyclePageDataContext.stateFns.getURLJSONModel().getChartSettingsJSONModel().getChartType();
    const disabled = inProgress || isError || !loaded || lodash_1.default.isNil(lifecyclePageDataContext.state.data);
    return React.createElement(antd_1.Radio.Group, { value: chartType, size: "middle", disabled: disabled, optionType: "button", buttonStyle: "solid", onChange: onRadioChange },
        React.createElement(antd_1.Radio.Button, { value: LifecycleChartSettingsJSONModel_1.ChartType.classicWithCounters },
            React.createElement(icons_1.BarChartOutlined, null)),
        React.createElement(antd_1.Radio.Button, { value: LifecycleChartSettingsJSONModel_1.ChartType.classicWithPercents },
            React.createElement(icons_1.PercentageOutlined, null)),
        React.createElement(antd_1.Radio.Button, { value: LifecycleChartSettingsJSONModel_1.ChartType.overtime },
            React.createElement(icons_1.FieldTimeOutlined, null)),
        React.createElement(antd_1.Radio.Button, { value: LifecycleChartSettingsJSONModel_1.ChartType.quickRatio },
            React.createElement(icons_1.FunctionOutlined, null)));
};
exports.LifecycleChartsSettingsChartTypeComponent = LifecycleChartsSettingsChartTypeComponent;
